import { render, staticRenderFns } from "./identify.vue?vue&type=template&id=2d2e23e6&"
import script from "./identify.vue?vue&type=script&lang=js&"
export * from "./identify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports